import { FaWhatsapp } from "react-icons/fa";

function NavBar() {
  return (
    <div class="header-wrapper">
      <div class="top-bar">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div class="col-lg-4 col-md-12">
              <div class="logo">
                <a href="/">
                  {/* <h1>RightCash</h1> */}
                  <img src="img/logo-copy.png" alt="Logo" />
                </a>
              </div>
            </div>
            <div class="col-lg-8 col-md-7 d-none d-lg-block">
              <div class="row">
                <div class="col-4">
                  <div class="top-bar-item">
                    <div class="top-bar-icon" style={{ paddingTop: "14px" }}>
                      {/* <i class="flaticon-calendar"></i>
                       */}
                      <FaWhatsapp size={40} color="#0399cd" />
                    </div>
                    <div class="top-bar-text">
                      <h3>Whatsapp</h3>
                      <p>+447871092759</p>
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="top-bar-item">
                    <div class="top-bar-icon">
                      <i class="flaticon-call"></i>
                    </div>
                    <div class="top-bar-text">
                      <h3>Call Us</h3>
                      <p>01634 830987</p>
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="top-bar-item">
                    <div class="top-bar-icon">
                      <i class="flaticon-send-mail"></i>
                    </div>
                    <div class="top-bar-text">
                      <h3>Email Us</h3>
                      <p>chatham@rightcash.co.uk</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Top Bar End --> */}

      {/* <!-- Nav Bar Start --> */}
      <div class="nav-bar">
        <div class="container-fluid">
          <nav class="navbar navbar-expand-lg bg-dark navbar-dark">
            <a href="#" class="navbar-brand">
              MENU
            </a>
            <img class="mobile_logo" src="logo192.png" alt="Logo" height={50} />

            <button
              type="button"
              class="navbar-toggler"
              data-toggle="collapse"
              data-target="#navbarCollapse"
            >
              <span class="navbar-toggler-icon"></span>
            </button>

            <div
              class="collapse navbar-collapse justify-content-between"
              id="navbarCollapse"
            >
              <div class="navbar-nav mr-auto">
                <a href="/" class="nav-item nav-link ç">
                  Home
                </a>

                <a href="/buybacks" class="nav-item nav-link">
                  Buybacks
                </a>
                <a href="/instant-cash" class="nav-item nav-link">
                  Instant Cash
                </a>

                <a href="/pawn-broking" class="nav-item nav-link">
                  Pawnbroking
                </a>
                <a href="/we-sell" class="nav-item nav-link">
                  We Sell
                </a>

                <div class="nav-item dropdown">
                  <a
                    href="#"
                    class="nav-link dropdown-toggle"
                    data-toggle="dropdown"
                  >
                    More
                  </a>
                  <div class="dropdown-menu">
                    <a href="/privacy-policy" class="dropdown-item">
                      Privacy policy{" "}
                    </a>
                  </div>
                </div>
              </div>
              <div class="ml-auto">
                <a class="btn" href="/contact">
                  CONTACT US{" "}
                </a>
              </div>
            </div>
          </nav>
        </div>
        {/* <marquee width="100%" direction="right" height="30px" scrollamount="10">
          This is a sample scrolling text that has scrolls in the upper
          direction.
        </marquee> */}
      </div>
    </div>
  );
}

export default NavBar;
